import { getPremiumCareContent } from '../Constants';

// Shared premium disclaimer resolver used by PremiumCareDisclaimer,
// Quality tab premium popover/link, and print flows (Guest Print Directory,
// PrintCompareDrawer, PrintCompareShareDrawer) to keep messaging/link logic aligned.

type LagoonDisclaimerRow = {
  key?: string;
  message?: string;
  url?: string;
};

export type LagoonMessageRow = LagoonDisclaimerRow;

type LagoonDisclaimerInput = LagoonDisclaimerRow[] | undefined;

type ResolvePremiumCareDisclaimerParams = {
  locale: string;
  lagoonData?: LagoonDisclaimerInput;
  lagoonDisclaimerMessage?: string | null;
  lagoonDisclaimerUrl?: string | null;
};

type ResolvedPremiumCareDisclaimer = {
  content: string;
  linkText: string;
  url: string;
  popoverContent: string;
};

const PREMIUM_CARE_LAGOON_KEYS = [
  'PREMIUM_CARE_DISCLAIMER_CONTENT',
  'PREMIUM_CARE_DISCLAIMER',
];

const normalizeLagoonData = (
  lagoonData?: LagoonDisclaimerInput
): LagoonDisclaimerRow[] | undefined => {
  if (!lagoonData) return undefined;

  return lagoonData;
};

const getLagoonPremiumCareDisclaimer = (lagoonData?: LagoonDisclaimerInput) =>
  normalizeLagoonData(lagoonData)?.find((item) =>
    PREMIUM_CARE_LAGOON_KEYS.includes(item?.key ?? '')
  );

export const resolvePremiumCareDisclaimer = ({
  locale,
  lagoonData,
  lagoonDisclaimerMessage,
  lagoonDisclaimerUrl,
}: ResolvePremiumCareDisclaimerParams): ResolvedPremiumCareDisclaimer => {
  const premiumCareData = getPremiumCareContent(locale);
  const lagoonPremiumCareDisclaimer =
    getLagoonPremiumCareDisclaimer(lagoonData);
  const resolvedLagoonDisclaimerMessage =
    lagoonDisclaimerMessage ?? lagoonPremiumCareDisclaimer?.message;
  const resolvedLagoonDisclaimerUrl =
    lagoonDisclaimerUrl ?? lagoonPremiumCareDisclaimer?.url;

  return {
    content:
      resolvedLagoonDisclaimerMessage ??
      premiumCareData.disclaimerContent ??
      '',
    linkText: premiumCareData.disclaimerLinkText ?? '',
    url:
      (locale === 'es'
        ? premiumCareData.popoverURL
        : resolvedLagoonDisclaimerUrl ?? premiumCareData.popoverURL) ?? '',
    popoverContent: premiumCareData.popoverContent ?? '',
  };
};
